<template>
  <div class="cashbox-details container container_30">

    <div v-if="showKYC" class="cashbox-user__list-wrp">
      <cashbox-user :id="details.requestorId" :email="details.requestor" @close-kyc="showKYCForm(false)"/>
    </div>

    <div v-if="!showKYC" class="cashbox-details__form">
      <div class="cashbox-details__back">
        <md-button class="cashbox-details__back-btn md-icon-button" @click="closeForm">
          <md-icon>keyboard_arrow_left</md-icon>
          <md-tooltip md-direction="top">{{ i18n.lbl_go_back() }}</md-tooltip>
        </md-button>
      </div>

      <form @submit.prevent="closeForm">

        <div>
          <div class="md-title cashbox-details__title">{{ i18n.withdraw_details() }}</div>

          <div>
            <div>
              <span>{{ i18n.lim_request_id() }}</span>
              <span>{{id}}</span>
            </div>
            <div>
              <span>{{ i18n.lbl_request_state() }}</span>
              <span>{{ getStateText() }}</span>
            </div>
            <div v-if="details.destination && details.destination.length > 0">
              <span>{{ i18n.withdraw_ex_address() }}</span>
              <span>{{details.destination}}</span>
            </div>
            <div v-if="details.rejectReason && details.rejectReason.length > 0">
              <span>{{ i18n.lbl_reject_reason() }}</span>
              <span>{{details.rejectReason}}</span>
            </div>
            <div v-if="details.requestor && details.requestor.length > 0">
                <span>
                  <md-content class="kyc-button" @click="showKYCForm(true)">
                    &nbsp;&nbsp;{{ i18n.lbl_requestor() }}
                  </md-content>
                  <md-tooltip md-direction="left">{{ i18n.lbl_kyc() }}</md-tooltip>
                </span>
              <span>{{details.requestor}}</span>
            </div>
            <div>
              <span>{{ i18n.lbl_requestor_account_id() }}</span>
              <span>{{ details.requestorId }} </span>
            </div>
            <div>
              <span>{{ i18n.lbl_source_amount() }}</span>
              <span>{{ details.amount }}&nbsp;{{ details.destAssetCode }}</span>
            </div>
            <div>
              <span>{{ i18n.lbl_destination_amount() }}</span>
              <span>{{ details.amount }}&nbsp;{{ details.destAssetCode }}</span>
            </div>
            <div>
              <span>{{ i18n.lbl_fixed_fee() }}</span>
              <span>{{ details.fixedFee }}&nbsp;{{ details.destAssetCode }}</span>
            </div>
            <div>
              <span>{{ i18n.lbl_percent_fee() }}</span>
              <span>{{ details.percentFee }}&nbsp;{{ details.destAssetCode }}</span>
            </div>
            <div>
              <span>{{ i18n.lbl_total_fee() }}</span>
              <span>{{ details.totalFee }}&nbsp;{{ details.destAssetCode }}</span>
            </div>
            <div v-if="balance">
              <span>{{ i18n.lbl_balance() }}</span>
              <span>{{ balance }}&nbsp;{{ details.destAssetCode }}</span>
            </div>
            <div>
              <span>{{ i18n.withdraw_created() }}</span>
              <span>{{ details.created }}</span>
            </div>
            <div v-if="details.requestStateI !== REQUEST_STATES.pending">
              <span>{{ getDateTitleByState() }}</span>
              <span>{{ details.updated }}</span>
            </div>
          </div>

          <div class="btn-wrap space-between margin-top">

            <template v-if="details.requestStateI === 1" >
              <md-button class="btn btn_narrow md-primary"
                         @click="fulfill()"
                         :disabled="isSubmitting">
                {{ i18n.withdraw_approve() }}
              </md-button>

              <md-button class="btn btn_narrow md-primary"
                         @click="selectForRejection()"
                         :disabled="isSubmitting">
                {{ i18n.withdraw_reject() }}
              </md-button>
            </template>

            <template v-else>
              <md-button class="btn btn_narrow md-primary" @click="closeForm">
                {{ i18n.lbl_close() }}
              </md-button>
            </template>
          </div>
        </div>
      </form>

      <modal v-if="showRejectConfirm"
             @close-request="clearRejectionSelection()"
             max-width="40rem"
      >

        <form id="details-reject-form"
              @submit.prevent="reject() && clearRejectionSelection()">

          <div class="details-reject__form-row">
            <input-field
              class="reject_reason-input"
              name="reject_reason"
              :label="i18n.withdraw_reject_reason_prompt()"
              v-model="rejectForm.reason"
              @input="clearRejectFromError"/>
            <span v-show="formErrors.confirmReject.error" class="small_danger">
              {{formErrors.confirmReject.message}}
          </span>
          </div>
        </form>

        <div class="btn-wrap space-between margin-top">

          <md-button
            class="btn btn_narrow md-primary"
            @click="validateRejectReason() && reject()"
            form="details-reject-form-reject-form"
            :disabled="isSubmitting">
            {{ i18n.withdraw_reject() }}
          </md-button>

          <md-button
            class="btn btn_narrow md-primary"
            @click="clearRejectionSelection"
            :disabled="isSubmitting">
            {{ i18n.lbl_cancel() }}
          </md-button>

        </div>
      </modal>
    </div>
  </div>
</template>

<script>
  import formMixin from '@com/mixins/form.mixin'
  import InputField from '@com/fields/InputField'
  import Modal from '@com/modals/Modal'
  import { REQUEST_STATES } from '@const'

  import { i18n } from '@js/i18n'
  import { confirmAction } from '@js/modals/confirmation_message'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import {ErrorHandler} from '@js/errors/error_handler'
  import {errors} from '@js/errors/factory'
  import { reviewableRequestsService } from '@api/reviewable_requests.service'
  import { accountsService } from '@api/accounts.service'
  import CashboxUser from './Cashbox.User'

  export default {
    name: 'cashbox-details',
    mixins: [formMixin],
    components: { CashboxUser, InputField, Modal },
    props: ['id'],
    data: _ => ({
      REQUEST_STATES,
      showKYC: false,
      details: {},
      restoreFilters: {},
      balance: '',
      showRejectConfirm: false,
      rejectForm: {
        reason: ''
      },
      i18n,
      isSubmitting: false,
      formErrors: {
        confirmReject: { error: false, message: '' }
      }
    }),
    created () {
      this.details = this.$parent.getRequest(this.id)
      this.restoreFilters = this.$parent.getRestoreFilters()
      this.loadBalance()
      document.addEventListener('keydown', this.onDocumentKeyDown, false)
    },
    destroyed () {
      document.removeEventListener('keydown', this.onDocumentKeyDown, false)
    },
    methods: {
      getStateText () {
        return this.$parent.getRequestStateText(this.details.requestStateI)
      },
      getDateTitleByState () {
        if (this.details.requestStateI === REQUEST_STATES.pending) {
          return i18n.withdraw_created()
        } else if (this.details.requestStateI === REQUEST_STATES.approved) {
          return i18n.withdraw_approved()
        } else if (this.details.requestStateI === REQUEST_STATES.permanentlyRejected ||
          this.details.requestStateI === REQUEST_STATES.rejected) {
          return i18n.withdraw_rejected()
        }
        return i18n.withdraw_cancelled()
      },
      async loadBalance () {
        const balances = await accountsService.loadDetailsForEachBalance(this.details.requestorId)
        const currentBalance = balances.find(balance => balance.asset === this.details.destAssetCode)
        const amount = currentBalance.balance || '0.00'
        this.balance = this.$parent.getFiatFloat(amount, 2)
      },
      async fulfill () {
        if (!await confirmAction()) return
        this.isSubmitting = true
        try {
          await reviewableRequestsService.reviewWithdraw({reason: ''}, this.details)
          EventDispatcher.dispatchShowSuccessEvent(i18n.withdraw_request_approved())
          this.closeForm(REQUEST_STATES.approved)
        } catch (error) {
          if (error instanceof errors.TFAExceededCodeError) {
            EventDispatcher.dispatchShowErrorEvent(i18n.tfa_to_many_attempts())
          } else {
            ErrorHandler.processUnexpected(error)
          }
        }
        this.isSubmitting = false
      },
      clearRejectFromError () {
        this.formErrors.confirmReject = { error: false, message: '' }
        return true
      },
      validateRejectReason () {
        const reasonMsg = this.rejectForm.reason.trim()
        if (!reasonMsg.length) {
          this.formErrors.confirmReject = { error: true, message: i18n.withdraw_reject_reason_warn() }
          return false
        }
        return true
      },
      async reject () {
        this.isSubmitting = true
        try {
          await reviewableRequestsService.reviewWithdraw({
            reason: this.rejectForm.reason.trim(),
            isPermanent: true
          }, this.details)
          EventDispatcher.dispatchShowSuccessEvent(i18n.withdraw_request_rejected())
          this.closeForm(REQUEST_STATES.permanentlyRejected)
        } catch (error) {
          const errmsg = await error
          console.error(errmsg.toLocaleString())
          EventDispatcher.dispatchShowErrorEvent(errmsg.toLocaleString())
        }
        this.isSubmitting = false
        return true
      },
      selectForRejection (item) {
        this.showRejectConfirm = true
        this.rejectForm.reason = ''
      },
      clearRejectionSelection () {
        this.showRejectConfirm = false
      },
      showKYCForm (show) {
        this.showKYC = show
      },
      closeForm (newState = 0) {
        if (newState > 0) this.restoreFilters.state = newState
        this.$emit('close-details', this.restoreFilters)
      },
      onDocumentKeyDown (event) {
        const keyCode = event.which || event.keyCode
        if (keyCode === 27) { // esc key
          this.closeForm()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';

  .cashbox-details {
    &__title {
      margin: 12px 0;
    }

    .btn-wrap {
      max-width: 300px;
    }
  }

  .reject_reason-input {
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .small_danger {
    padding-top: 0;
    margin-top: 0;
    font-size: 0.7rem;
    font-weight: bold;
/*    color: $col-danger;*/
  }
  .kyc-button {
    max-width: 6rem;
    margin-left: -8px;
/*    background: $gray;*/
    &:hover {
/*      background: $blue !important;
      color: $white !important;*/
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/cashbox/index/Cashbox.Details.vue